'use client'

import { useEffect } from 'react'
import { startKeyboardInsetTracking } from '../helpers/keyboardInset'

// Renders nothing: it exists to publish `--pc-keyboard-inset` for the whole app,
// so any bottom-anchored surface can lift above the on-screen keyboard with a
// plain CSS calc and no per-page JS. Mounted once in the root layout.
export default function KeyboardInsetWatcher() {
  useEffect(() => startKeyboardInsetTracking(), [])
  return null
}
